import { EKO_GITHUB_URL, FELLOU_GITHUB_URL, FELLOU_WEBSITE_URL } from "@/app/config";
// export const productList = [
//   {
//     title: `Discord`,
//     path: "https://discord.com/invite/Ecxgn9B2MS",
//   },
//   {
//     title: `Join Us`,
//     path: "https://salt-sovereign-101.notion.site/Fellou-Join-Us-14936270eaab8095bfd2cfe72a682ead",
//   },
// ];
export const productList = [
  [
    {
      title: `Use Cases`,
      path: "/use-cases/",
      toway: 1,
    },
    {
      title: `Download`,
      path: "/download/",
      toway: 1,
    },
    // {
    //   title: `Supported Platforms`,
    //   path: "#",
    // },
    // {
    //   title: `Pricing`,
    //   path: "#",
    // },
  ],
  [
    {
      title: `Eko Decumentation`,
      path: `${FELLOU_WEBSITE_URL}/eko/docs/`,
      toway: 0,
    },
    {
      title: `Github Repo`,
      path: EKO_GITHUB_URL,
      toway: 0,
    },
    {
      title: `Quickstart Guide`,
      path: `${FELLOU_WEBSITE_URL}/eko/docs/getting-started/quickstart/`,
      toway: 0,
    },
  ],
  [
    // {
    //   title: `About`,
    //   path: "#",
    // },
    {
      title: `Blog`,
      path: `${FELLOU_WEBSITE_URL}/blog`,
      toway: 1,
    },
    {
      title: `Join us`,
      path: "https://salt-sovereign-101.notion.site/Fellou-Join-Us-14936270eaab8095bfd2cfe72a682ead",
      toway: 0,
    },
  ],
  [
    {
      title: `Terms of Service`,
      path: "/terms/",
      toway: 1,
    },
    {
      title: `Privacy Policy`,
      path: "/policy/",
      toway: 1,
    },
  ],
];

export const communityLink = [
  {
    imgUrl: "//files.authing.co/authing-website/github.svg",
    icon: "iicon iconfont icon-twitter-x-line",
    path: "//x.com/FellouAI",
    type: "wechat",
    bg: "#2FDF6E",
  },
  {
    imgUrl: "//files.authing.co/authing-website/github.svg",
    icon: "icon iconfont icon-discord-fill",
    path: "https://discord.com/invite/Ecxgn9B2MS",
    bg: "#000",
    log: "footer/githubicon",
  },

  {
    imgUrl: "//files.authing.co/authing-website/zhihu.svg",
    icon: "icon iconfont icon-youtube-fill",
    path: "//www.youtube.com/@Fellouai",
    bg: "#0066FF",
    log: "footer/zhihuicon",
  },
  {
    imgUrl: "//files.authing.co/authing-website/gitter.svg",
    icon: "icon iconfont icon-github-fill",
    path: FELLOU_GITHUB_URL,
    bg: "#FFCB1B",
    log: "footer/forumicon",
  },
];
